import { render, staticRenderFns } from "./graphicBrenchPressMasculine.vue?vue&type=template&id=afe0930c&"
import script from "./graphicBrenchPressMasculine.js?vue&type=script&lang=js&"
export * from "./graphicBrenchPressMasculine.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports